import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { securityEntityContent } from './SecurityInsightsExtensions';

/**
 * In-house per-service Security tab: Dependabot alerts straight from the
 * GitHub REST API (the same endpoint the Home page Security tab counts
 * from). Replaced the Roadie security-insights plugin — see the rationale
 * in SecurityInsightsExtensions.tsx. The pluginId stays 'security-insights'
 * so the extension id and its app-config.yaml ordering entry remain
 * entity-content:security-insights/security.
 */
export const securityInsightsPlugin = createFrontendPlugin({
  pluginId: 'security-insights',
  extensions: [securityEntityContent],
});
